import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  useExecutorRoleContext,
  useUserRolePreferencesSettingsContext,
} from '../../../../context/contexts';
import { GlobalFilterTypeHandle } from '../../../../context/types';
import { Filter } from '../filterbar/types';
import { FilterSection } from '../types';
import { MyFilterItem } from './MyFilterItem';
import { MyFiltersGroup } from './types';

interface MyFilterItemListProps {
  filtersHandle: GlobalFilterTypeHandle<Filter>;
  setExpand: (value: boolean) => void;
  filterSections: FilterSection[];
}

export const MyFilterItemList = (props: MyFilterItemListProps) => {
  const { t } = useTranslation();
  const { filtersHandle, setExpand, filterSections } = props;

  const executorRole = useExecutorRoleContext();
  const currentRolePreferences = useUserRolePreferencesSettingsContext();
  const groups = currentRolePreferences?.settings?.myFilterGroups ?? [];
  const groupsForCurrentExecutorRole = groups.filter(
    (g) => g.executorRoleId === executorRole.id
  );

  if (
    !groupsForCurrentExecutorRole ||
    groupsForCurrentExecutorRole.length === 0
  ) {
    return (
      <Grid container item p={1}>
        <Typography>{t('common:filterTray.noFilterGroupsCreated')}</Typography>
      </Grid>
    );
  }
  return (
    <>
      {groupsForCurrentExecutorRole.map((group: MyFiltersGroup<Filter>) => (
        <MyFilterItem<Filter>
          key={group.id}
          group={group}
          filtersHandle={filtersHandle}
          currentRolePreferences={currentRolePreferences}
          setExpand={setExpand}
          filterSections={filterSections}
        />
      ))}
    </>
  );
};
